import React from "react";
import * as Ph from "@phosphor-icons/react";
import { ArrowUpRight } from "lucide-react";
import { Button } from "../ui/button";
import { Reveal, Starburst } from "../common";
import { useLead } from "../LeadDialog";
import { CAREER_BENEFITS } from "../../data/site";

const Careers = () => {
  const { openLead } = useLead();
  return (
    <section
      id="careers"
      className="relative py-24 md:py-32 bg-jet-ink text-white overflow-hidden scroll-mt-20"
      data-testid="careers-section"
    >
      <Starburst className="absolute top-16 left-[8%] h-24 w-24 text-white/[0.04]" />
      <div className="max-w-[88rem] mx-auto px-5 md:px-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <Reveal>
            <div className="inline-flex items-center gap-2 text-xs md:text-sm font-bold uppercase tracking-[0.22em] text-jet-amber mb-5">
              <Starburst className="h-3 w-3 text-jet-amber" /> Careers
            </div>
            <h2 className="font-display font-semibold text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tight">
              Join the Jet Cleaning team.
            </h2>
            <p className="mt-6 text-white/60 text-lg leading-relaxed max-w-md">
              We're always looking for dependable, detail-oriented contract
              cleaning professionals who take pride in doing great work.
            </p>
            <Button
              onClick={() => openLead("careers")}
              className="mt-8 rounded-full bg-jet-teal hover:bg-jet-teal-deep text-white font-bold h-14 px-8 teal-glow group"
              data-testid="careers-apply-button"
            >
              Apply Online
              <ArrowUpRight className="h-5 w-5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Button>
          </Reveal>

          <div className="grid grid-cols-2 gap-4">
            {CAREER_BENEFITS.map((b, i) => {
              const Icon = Ph[b.icon] || Ph.Star;
              return (
                <Reveal key={b.title} delay={i * 0.08}>
                  <div className="h-full rounded-2xl border border-white/10 bg-white/[0.03] p-6 hover:bg-white/[0.06] transition-colors">
                    <span className="grid place-items-center h-12 w-12 rounded-xl bg-jet-teal/20 text-jet-teal mb-4">
                      <Icon size={26} weight="duotone" />
                    </span>
                    <h3 className="font-display text-lg font-semibold">{b.title}</h3>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Careers;
